<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 12.6667V14.0001H13V12.6667H3Z" fill="currentColor" />
    <path
      d="M11.3821 6.91725L8.63892 4.3178L8.63892 11.3333L7.36094 11.3333L7.36094 4.3178L4.61775 6.91725L3.71422 6.06106L7.99993 1.99992L12.2856 6.06106L11.3821 6.91725Z"
      fill="currentColor"
    />
  </svg>
</template>
